import React from 'react';
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import Backdrop from '../Backdrop/Backdrop';
import Modal from '../Modal/Modal';
import ConvertUploadModalContent from './ConvertUploadModalContent';

import { useStore } from '../../hook-store/store';

import { marks } from '../../utils/marks';


export default function ConvertUpload(props) {
  const { 
    renders,
  } = props;

  const [t] = useTranslation('translation');
  // console.log('UploadEditFile-props', props);

  const [store, dispatch] = useStore();
  const {
    convertedFiles
  } = store.imageConvertStore;
  const { gLoading, isAuth, isAllApis } = store.uiStore;

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isLoading, setIsLoading] = useState();


  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);



  const showUploadMoadlHandler = (value) => {
    setShowUploadModal(value);
    // dispatch('SET_SHOW_LAMAUPLOADMODAL', value);
  }

 

  let imageConvertUploadBody;

  if (isAuth && isAllApis) {
    imageConvertUploadBody = (
      <button
        className='btnBase'
        disabled={convertedFiles.length === 0}
        onClick={() => {
          if (!isLoading) {
            showUploadMoadlHandler(true);
          }
          // cleanImageUploadHandler(''); 
        }}
      >
        {marks.uploadMark} {t('imageConvert12', 'Upload Converted files')}
        {convertedFiles.length > 0 && (
          <span> ({convertedFiles.length})</span>
        )}
      </button>
    );
  }


  return (
    <Fragment>
      {imageConvertUploadBody}
      {showUploadModal && (
        <div>
          <Backdrop 
            onCancel={() => { 
              if (!isLoading) {
                showUploadMoadlHandler(false);
              }
            }}
          />
          <Modal
            onClose={() => { 
              if (!isLoading) {
                showUploadMoadlHandler(false);
              }
            }}
          >
            <ConvertUploadModalContent 
              showUploadMoadlHandler={showUploadMoadlHandler}
            />
          </Modal>
        </div>
      )}
    </Fragment>
  );
}

